"use client";
import React, {useCallback, useState} from "react";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {LoginType, selectUserInfo} from "@/app/userSlice";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import $http from "@/app/_api";
import {PayStatus} from "@/app/(pay)/types";
import BigTips from "@/Master/BigTips";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {QueryOrderResponse, ShopItem} from "@/app/_api/types/store";
import {RewardDialogFC} from "@/app/_dialogs/RewardDialog/RewardDialog";
import PayUtil from "@/Core/Pay/PayUtil";
import RouterMgr from "@/Core/RouterMgr";
import {VisitorRechargeDialogFC} from "@/app/(shop)/UI/VisitorRechargeDialog/VisitorRechargeDialog";
import {SpecialGiftPackDialogFC} from "@/app/(shop)/UI/SpecialGiftPackDialog/SpecialGiftPackDialog";
import {FirstChargeGiftPackDialogFC} from "@/app/(shop)/UI/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import styles from "./PayWaitingDialog.module.css";
import Util from "@/Master/Util";
import {getPaymentItemsAsync} from "@/app/(pages)/paymentItemsAPI";

interface PayWaitingDialogProps extends SDialogProps {
    ks: string;
    pType: string;
    shopItem: ShopItem;
}

export const PayWaitingDialogFC: React.FC<PayWaitingDialogProps> = (props) => {
    const {fcKey, ks, pType, shopItem, onClose} = props;

    const {closeDialog} = useDialogMethods(fcKey);

    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUserInfo);

    const [isPayOk, setIsPayOk] = useState<boolean>(false);

    const onCloseCall = () => {
        closeDialog();
        onClose?.();
    }

    useCallback(() => {
        if (isPayOk) {
            RouterMgr.signup();
        }
    }, [isPayOk]);

    // 查询支付结果
    const queryPayResult = () => {
        return $http.Store.queryOrder({
            ks,
            ptype: pType
        });
    }

    // 用户点击确认按钮连续7次校验支付结果
    const onConfirmPayResult: () => void = async () => {
        let tasks = new Array(7).fill(queryPayResult),
            isWaitingPay = false,
            hasPayResult = true;
        for (let result of tasks) {
            let responseData: QueryOrderResponse = await result();
            if (Util.isLog) {
                console.log("支付结果", responseData);
            }
            if (!responseData?.orderStatus) {
                hasPayResult = false
                break;//跳出 用户下次点击后可继续查询。不关闭页面
            }
            if (responseData.orderStatus !== PayStatus.WAITING) {
                if (responseData.orderStatus == PayStatus.SUCCESS) {
                    onRewardAni(shopItem, responseData);
                    dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 1}));
                    dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 2}));
                    closeDialog();
                    onClose?.();
                    // console.log("支付结果已生成", responseData);
                    // onCloseCall();
                } else {
                    BigTips.showMsg(`${PayUtil.getPayStatusName(responseData.orderStatus)}`);
                }
                onCloseCall();
                break;
            }
            if (responseData.orderStatus === PayStatus.WAITING) {
                isWaitingPay = true;
            }
        }
        hideForceLoading()
        if (isWaitingPay) {
            BigTips.showMsg(`Waiting for payment.`);
        }
        if (!hasPayResult) {
            BigTips.showMsg(`No payment result found.`);
        }
        onCloseCall();
    }

    const onRewardAni = (item: ShopItem, data: QueryOrderResponse) => {
        SDialogManagerFC.openDialog(RewardDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RewardDialogFC),
            onClose: () => {
                //todo 后面奖励效果通过更新用户数据变动后更新顶部的数值滚动效果
                // SRewardUIPresenter.Instance.PlayRewardAnimation(item.gc, item.sc, EffectType.FlyIcon);
                // ShopMgr.checkUserForcedReg();
                //ShopMgr.checkShowRegDialog();
                if (SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC)) SDialogManagerFC.closeDialog(
                    SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC)
                )
                if (SDialogManagerFC.getFCKey(VisitorRechargeDialogFC)) SDialogManagerFC.closeDialog(
                    SDialogManagerFC.getFCKey(VisitorRechargeDialogFC)
                )
                if (SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC)) SDialogManagerFC.closeDialog(
                    SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC)
                )
                if (userInfo.loginType == LoginType.visitor) {
                    RouterMgr.signup([['from','payOk']]);
                }
            },
            gcCount: item.gc,
            scCount: data.totalSc,
        })
    }

    const handleConfirmation = () => {
        showForceLoading()
        onConfirmPayResult();
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            title={
                <p style={{marginBottom: ".4rem", fontSize: ".6rem", fontWeight: "bold"}}>
                    Payment is being processed..
                </p>
            }
            onClose={onClose}
            buttons={[
                {
                    label: "Confirmation",
                    onClick: handleConfirmation,
                    style: "greenBtn",
                },
            ]}
        >
            <section className={styles.content}>
                <section className={styles.payment_list_wrapper}>
                    After the payment is completed, please click the <span
                    style={{color: 'var(--mark-text-color)'}}>Confirmation</span> button. and the system will
                    automatically query the payment results.
                </section>
            </section>
        </SDialogFC>
    );
};